/* eslint-disable no-console */
/* eslint-disable react/require-default-props */
/**
 * 申請人資料填寫/查看
 */
import React, { useEffect, useState } from 'react';
import { LayoutForm as Form, Text } from '@/components/BaseForm';
import { useIntl, useSelector } from 'umi';
import type { UserState } from 'umi';
import { FormInstance } from 'antd';
import { MoAddress, MoPhone } from '@gov-mo/components';
import ApplicantInformations from '@/pages/foster-service/components/ApplicantInformations';
import areaCodeList from './areacode.json';
import type { PersonalFormType } from '../../types/defs';
import styles from './PersonalForm.less';

export interface PersonalFormProps extends React.HTMLAttributes<HTMLDivElement> {
  isDetail?: boolean;
  onInstance?: (instance: FormInstance | null) => void;
  mobile?: boolean;
  values?: PersonalFormType & Record<string, unknown>;
}

export interface FormValues {
  spouseName?: string;
  applicantEmail?: string;
  phone?: string;
  address?: string;
  addressObj?: unknown; // 添加地址对象字段
  agreement?: boolean;
}

const PersonalForm = (props: PersonalFormProps) => {
  const intl = useIntl();
  const { brandColor } = useSelector(x => x.public);
  const { onInstance, isDetail = false, values, mobile = true } = props;
  const [form] = Form.useForm();
  const [addressObj, setAddressObj] = useState<unknown>(null); // 添加state来存储地址对象
  // 获取用户信息
  const { profile } = useSelector(({ user }: { user: UserState }) => user);

  // 初始化电话号码 - 只在 profile 变化时执行
  useEffect(() => {
    if (profile?.mobile) {
      const areaCodesConfig = areaCodeList.map(item => item.code);
      let area = '+853'; // 默认地区代码
      let mobileNumber = profile.mobile;
      // 查找匹配的地区代码
      if (profile?.mobile && typeof profile.mobile === 'string' && profile.mobile.indexOf('+') !== -1) {
        for (const code of areaCodesConfig) {
          if (profile.mobile.startsWith(code)) {
            area = code;
            mobileNumber = profile.mobile.substring(code.length);
            break;
          }
        }
      }
      form.setFieldsValue({
        phone: {
          area: area,
          number: mobileNumber,
        },
      });
    }
  }, [profile]);

  // 延迟执行DOM操作和表单实例设置
  useEffect(() => {
    setTimeout(() => {
      const phoneLabel = document.querySelector('[title="聯繫電話"]');
      if (phoneLabel) {
        phoneLabel.textContent = intl.formatMessage({ id: '聯繫電話' });
        // 获取父元素并添加类名
        const parentElement = phoneLabel.closest('.ant-form-item-label');
        if (parentElement) {
          parentElement.classList.add('ant-col-4');
        }
      }
    }, 0);

    onInstance?.({
      ...form,
      validateFields: () =>
        form.validateFields().then((vals: FormValues) => ({
          ...vals,
          addressObj, // 将地址对象添加到表单值中
        })),
      setFieldsValue: (vals: PersonalFormType) => {
        form.setFieldsValue({
          ...vals,
        });
      },
    });
  }, [addressObj]);

  // 设置其他表单值 - 只在 values 变化时执行
  useEffect(() => {
    if (values) {
      form.setFieldsValue({
        ...values,
      });
    }
  }, [values]);


  // 詳情顯示內容
  if (isDetail) {
    return (
      <div className={`${mobile ? styles.detailRoot : styles.webDetailRoot}`}>
        {/* 預置鍵測試 */}
        <div role="text">
          <span>{intl.formatMessage({ id: '配偶姓名' })}</span>
          <span>{`${values?.spouseName}`}</span>
        </div>
        <div role="text">
          <span>{intl.formatMessage({ id: '聯繫電話' })}</span>
          <span>{`${values?.phone?.area}-${values?.phone?.number}`}</span>
        </div>
        {/* 地址 */}
        <div role="text">
          <span>{intl.formatMessage({ id: '地址' })}</span>
          <span>{values?.formFieldAddress}</span>
        </div>

      </div>
    );
  }

  // 編輯顯示內容
  return (
    <>
      {/* 申請人資料顯示 */}
      <ApplicantInformations />

      {/* {mobile && (
        <div className={styles.baseTitleContainer}>
          {intl.formatMessage({ id: '申請資料' })}
        </div>
      )} */}
      <Form form={form} className={`${styles.root} ${mobile ? styles.mobileForm : ''}`}>

      {/* 使用Text组件作为普通輸入框示例 */}
        <Form.Item
          label={intl.formatMessage({ id: '配偶姓名' })}
          name="spouseName"
          rules={[{ required: true, message: intl.formatMessage({ id: '請輸入' }) }]}
          wrapperCol={mobile ? { span: 24 } : { span: 20 }}
          labelCol={mobile ? { span: 24 } : { span: 4 }}
        >
          <Text placeholder={intl.formatMessage({ id: '請輸入' })} />
        </Form.Item>
        <MoPhone
          required
          formItemProps={{
            label: '聯繫電話',
          }}
        />
        {/* 地址 */}
        <Form.Item
          label={intl.formatMessage({ id: '地址' })}
          rules={[{ required: true, message: intl.formatMessage({ id: '請選擇' }) }]}
          name="formFieldAddress"
          wrapperCol={mobile ? { span: 24 } : { span: 20 }}
          labelCol={mobile ? { span: 24 } : { span: 4 }}
        >
          <MoAddress
            brandColor={brandColor}
            onChange={(addrStr, addObj) => {
              // console.log('🚀 ~ PersonalForm ~ addrStr, addObj:', addrStr, addObj);
              // 同时设置地址字符串和地址对象到表单
              form.setFieldsValue({
                formFieldAddress: addrStr,
                addressObj: addObj,
              });
            }}
            onStreetChange={(streetData) => {
              // console.log('🚀 ~ PersonalForm ~ streetData:', streetData);
            }}
            onResAddrSplit={(addrObj) => {
              // console.log('🚀 ~ PersonalForm ~ addrObj:', addrObj);
              // 保存地址对象到state中
              setAddressObj(addrObj);
              // 同时更新表单中的addressObj字段
              form.setFieldsValue({
                addressObj: addrObj,
              });
            }}
          />
        </Form.Item>
      </Form>
    </>
  );
};

export default PersonalForm;
